import { Modal } from "flowbite-react";
import FormDeleteExternalServices from "../forms/FormDeleteExternalServices";

type Props = {
    onClose: () => void;
    onSave?: () => void;
    id: string;
};

export default function CancelarExternalServicesModal({ onClose, onSave, id }: Props) {
    const handleCloseModal = () => {
        onSave?.();   
        onClose();   
    };
    return (
        <Modal className='relative text-black' size="5xl" show={true} onClose={onClose}>
            <Modal.Header className='text-black dark:text-black'>
                <h2 className="text-black">Cancelar Serviço Externo </h2>
            </Modal.Header>
            <Modal.Body className='text-black dark:text-black'>
                <FormDeleteExternalServices id={id} onSubmit={handleCloseModal} onCancel={onClose} />
            </Modal.Body>
        </Modal>
    );
}
